import { useRef } from 'react'
import styled from 'styled-components'

import { zIndex } from '@/styles'
import useSessionComplete from '@/hooks/use-session-complete'
import { ListingCardItem } from '@/features/ListingsMap/map-list/listing-card-item'
import { useTermsDialogContext } from '@/components/terms-dialog/context'

const Wrapper = styled.div`
  width: 100%;
  bottom: 11vh;
  left: 2.5vw;
  position: absolute;
  max-width: 95vw;
  z-index: ${zIndex.mapCarousel};
`

const MapListingCarousel = ({ data = {}, handleClose }) => {
  const isLoggedIn = useSessionComplete()

  const { isLoading, checkAgreementMismatch } = useTermsDialogContext()
  const isAgreementMismatched = checkAgreementMismatch('trreb_agreements')
  const isLoadingAgreements = isLoading && isLoggedIn

  const listingCardRef = useRef()

  if (!data.listing_id) return null

  return (
    <Wrapper ref={listingCardRef}>
      <ListingCardItem
        id={data.listing_id}
        listing={data}
        isFeatured={false}
        hasSession={isLoggedIn}
        isAgreementMismatched={isAgreementMismatched}
        isAgreementLoading={isLoadingAgreements}
        onListingHover={() => {}}
        onClick={() => {}}
        onClose={handleClose}
        trackImpression={{
          id: data.listing_id,
          enabled: true,
          page: 'listings',
          section: 'listing-card',
          sponsored: true
        }}
      />
    </Wrapper>
  )
}

export default MapListingCarousel
